"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    var _a;
    return (0, styles_1.createStyles)({
        sliderWrapper: {
            position: 'relative',
            marginBottom: '80px',
            // slick carousel styles converted by https://transform.tools/css-to-js
            // slick.css
            '& .slick-slider': (_a = {
                    position: 'relative',
                    display: 'block',
                    boxSizing: 'border-box',
                    userSelect: 'none',
                    touchAction: 'pan-y',
                    WebkitTapHighlightColor: 'transparent',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: 'calc(100% - 72px)',
                    maxWidth: '1264px',
                    paddingLeft: 'calc(((100% / 12) * 1 - 48px))',
                    paddingRight: 'calc(((100% / 12) * 1 - 24px))'
                },
                _a[theme_1.default.breakpoints.up('xl')] = {
                    padding: '0 48px',
                },
                _a),
            '& .slick-list': {
                position: 'relative',
                display: 'block',
                overflow: 'visible',
                margin: 0,
                padding: 0,
            },
            '& .slick-list:focus': {
                outline: 'none',
            },
            '& .slick-list.dragging': {
                cursor: ['pointer', 'hand'],
            },
            '& .slick-slider .slick-track, & .slick-slider .slick-list': {
                transform: 'translate3d(0, 0, 0)',
            },
            '& .slick-track': {
                position: 'relative',
                top: 0,
                left: 0,
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
            },
            '& .slick-track:before, & .slick-track:after': {
                display: 'table',
                content: "''",
            },
            '& .slick-track:after': {
                clear: 'both',
            },
            '& .slick-loading .slick-track': {
                visibility: 'hidden',
            },
            '& .slick-slide': {
                display: 'none',
                float: 'left',
                height: '100%',
                minHeight: '1px',
                padding: '0 23px',
            },
            '& .slick-slide *': {
                outline: 'none !important',
            },
            "[dir='rtl'] .slick-slide": {
                float: 'right',
            },
            '& .slick-slide img': {
                display: 'block',
            },
            '& .slick-slide.slick-loading img': {
                display: 'none',
            },
            '& .slick-slide.dragging img': {
                pointerEvents: 'none',
            },
            '& .slick-initialized .slick-slide': {
                display: 'block',
            },
            '& .slick-loading .slick-slide': {
                visibility: 'hidden',
            },
            '& .slick-vertical .slick-slide': {
                display: 'block',
                height: 'auto',
                border: '1px solid transparent',
            },
            '& .slick-arrow.slick-hidden': {
                display: 'none',
            },
            '& .slick-slide:not(.slick-active)': {
                position: 'relative',
            },
            '& .slick-overlay::before': {
                content: "''",
                position: 'absolute',
                left: 0,
                width: '10%',
                height: '100%',
                background: 'linear-gradient(-90deg, rgba(248, 249, 253, 0) 0%, rgb(248, 249, 253) 100%)',
                zIndex: 1,
            },
            '& .slick-overlay::after': {
                content: "''",
                position: 'absolute',
                right: 0,
                top: 0,
                width: '10%',
                height: '100%',
                background: 'linear-gradient(-90deg, rgb(248, 249, 253) 0%, rgba(248, 249, 253, 0) 100%)',
                zIndex: 1,
            },
            // slickTheme.css
            '& .slick-prev,& .slick-next': {
                fontSize: 0,
                lineHeight: 0,
                position: 'absolute',
                top: '50%',
                padding: 0,
                transform: 'translate(0, -50%)',
                cursor: 'pointer',
                color: 'transparent',
                border: 'none',
                outline: 'none',
                background: 'rgb(255, 255, 255)',
                boxShadow: '0px 9px 10px 0px rgba(0, 0, 0, 0.2)',
                height: '40px',
                width: '40px',
                borderRadius: '50%',
                zIndex: 2,
                display: 'flex !important',
                justifyContent: 'center',
                alignItems: 'center',
            },
            '& .slick-prev:hover,& .slick-prev:focus,& .slick-next:hover,& .slick-next:focus': {
                color: 'transparent',
                outline: 'none',
            },
            '& .slick-prev:hover:before,& .slick-prev:focus:before,& .slick-next:hover:before,& .slick-next:focus:before': {
                opacity: 1,
            },
            '& .slick-prev.slick-disabled,& .slick-next.slick-disabled': {
                opacity: 0,
                zIndex: -1,
            },
            '& .slick-prev:before,& .slick-next:before': {
                fontFamily: "'slick'",
                fontSize: '20px',
                lineHeight: 1,
                opacity: 0.75,
                color: 'white',
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            },
            '& .slick-prev': {
                left: 0,
            },
            "& [dir='rtl'] .slick-prev": {
                right: 0,
                left: 'auto',
            },
            '& .slick-next': {
                right: 0,
            },
            "& [dir='rtl'] .slick-next": {
                right: 'auto',
                left: 0,
            },
        },
        sliderInnerWrapper: {
            overflow: 'hidden',
        },
        arrow: {
            background: 'white',
            boxShadow: '0px 9px 10px 0px rgba(0, 0, 0, 0.2)',
            height: '40px',
            width: '40px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        nextArrow: {
            transform: 'rotate(-90deg)',
        },
        prevArrow: {
            transform: 'rotate(90deg) translateY(1px)',
        },
    });
});
